import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      trackAddToCart();
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    onClick?.();
  };
  return <motion.button animate={{
    x: [0, -2, 2, -3, 3, -1, 1, 0],
    y: [0, 1, -1, 1, -1, 0]
  }} transition={{
    duration: 0.6,
    repeat: Infinity,
    repeatDelay: 2.5,
    ease: 'easeInOut'
  }} whileHover={{
    scale: 1.05,
    x: 0,
    y: 0
  }} whileTap={{
    scale: 0.96
  }} onClick={handleClick} className={`
        relative overflow-hidden group
        bg-gradient-to-r from-gold-600 via-gold-400 to-gold-600
        text-emerald-950 font-heading font-bold text-xl md:text-2xl
        py-4 px-8 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.3)]
        transition-shadow duration-300 hover:shadow-[0_0_40px_rgba(212,175,55,0.6)]
        ${className}
      `} style={{
    backgroundSize: '200% auto'
  }} data-id="element-183">
      <span className="relative z-10" data-id="element-184">{children}</span>

      {/* Shimmer effect */}
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2.5s_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent z-0" data-id="element-185" />
    </motion.button>;
}